module.exports = __webpack_public_path__ + "public/Icons/13Vehicletype.svg?cb718e92";